import { SlashCircle01Icon } from '@systemeio/icons';
import { createInactivePage } from 'modules/funnels/funnel/api/funnel-api';
import { NavigationCard } from 'modules/funnels/funnel/components/navigation-card';
import { NavigationTitle } from 'modules/funnels/funnel/components/navigation-title';
import { useFunnel } from 'modules/funnels/funnel/hooks/use-funnel';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import React, { useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { getPageEditorUrl } from 'shared/utils/get-page-editor-url';
import { twJoin } from 'tailwind-merge';
interface InactivePageProps {
  funnelId: FunnelId;
}
function InactivePage({
  funnelId
}: InactivePageProps) {
  const {
    t
  } = useLocoTranslation();
  const {
    funnel,
    mutateFunnel
  } = useFunnel(funnelId);
  const [isFetching, setIsFetching] = useState(false);
  const handleClickInactivePage = async () => {
    if (funnel) {
      if (funnel.inactivePage) {
        window.location.assign(getPageEditorUrl(funnel.inactivePage.id));
      } else {
        setIsFetching(true);
        try {
          const response = await createInactivePage(funnelId);
          const inactivePageId = response.data.inactivePage.id;
          await mutateFunnel(data => {
            if (data) {
              return {
                ...data,
                inactivePage: {
                  id: inactivePageId
                }
              };
            }
          }, false);
          window.location.assign(getPageEditorUrl(inactivePageId));
          setIsFetching(false);
        } catch {} finally {
          setIsFetching(false);
        }
      }
    }
  };
  return <div className={'flex flex-col pb-2'}>
      <div className={'desktop:py-5 py-3'}>
        <NavigationTitle>{t('dashboard.funnel.steps.fallback')}</NavigationTitle>
      </div>
      <NavigationCard data-base-ui-swipe-ignore className={twJoin('hover:bg-bg-tertiary focus-visible:focus-ring-primary', isFetching && 'cursor-wait')} onClick={!isFetching ? handleClickInactivePage : undefined} title={t('dashboard.funnel.inactive_page')} subtitle={t('dashboard.funnel.inactive_page_description')} icon={<SlashCircle01Icon />} />
    </div>;
}
export default InactivePage;